import React from 'react';
import { gql } from '@apollo/client';
import { ReferenceField, Show, SimpleShowLayout, TextField } from 'react-admin';

const HrisLocationMappingShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <ReferenceField label="Company" source="company_id" reference="Company" link="show">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField label="Location" source="location_id" reference="Location" link="show">
        <TextField source="name" />
      </ReferenceField>
      <TextField label="External ID" source="external_id" />
    </SimpleShowLayout>
  </Show>
);

HrisLocationMappingShow.query = gql`
  query hrisLocationMapping($id: Int!) {
    hrisLocationMapping(id: $id) {
      id
      company_id
      location_id
      external_id
    }
  }
`;

export default HrisLocationMappingShow;
